<template>
  <ValidationObserver
    ref="form"
    v-slot="{ handleSubmit, reset }"
  >
    <form
      autocomplete="off"
      @submit.prevent="handleSubmit(submit)"
      @reset.prevent="reset"
    >
      <modal
        v-model="modalOpened"
        :title="$t('login.create_account.create_account')"
        cancel-text=" "
        ok-text=" "
      >
        <ValidationProvider
          v-slot="{ errors }"
          rules="required|email"
          :name="$t('login.create_account.email_address')"
          vid="email"
          slim
        >
          <div class="row">
            <div
              class="col-xs-12"
            >
              <div
                class="alert alert-warning"
              >
                {{ $t('login.create_account.info') }}
              </div>
            </div>
          </div>
          <div
            class="form-group panel-body"
            :class="{'has-error': errors.length}"
            style="margin-bottom: 0; padding-bottom: 0"
          >
            <label
              class="control-label"
              for="createAccountEmail"
            >
              {{ $t('login.create_account.email_address') }}
            </label>
            <PortalTooltip
              tip-id="emailHelp"
              :text="$t('login.create_account.hints.email')"
            />
            <input
              id="createAccountEmail"
              ref="email"
              v-model="account.email"
              name="email"
              autocomplete="email"
              class="form-control"
              type="email"
              :disabled="processingForm"
              :placeholder="$t('login.create_account.email_address')"
            >
            <div v-if="errors.length">
              <span
                v-for="(error, index) in errors"
                :key="index"
                class="help-block"
                role="alert"
              >
                <i class="fa fa-warning" />&nbsp;{{ error }}
              </span>
            </div>

            <!-- <span
              v-else-if="errors.length"
              class="help-block"
            >
              <i
                v-show="errors.length"
                class="fa fa-warning"
              />&nbsp;{{ errors[0] }}
            </span> -->
          </div>
        </ValidationProvider>
        <CardFormFields
          v-model="account.card"
          class="panel-body"
          :processing-form="processingForm"
        />
        <Privacy
          v-if="isDataProtectionUrlSet"
          ref="privacy"
          v-model="account.agreement"
          class="panel-body"
          :processing-form="processingForm"
          :modal-opened="modalOpened"
        />
        <div slot="footer">
          <button
            id="createAccountBtn"
            class="btn btn-primary pull-left"
            type="submit"
            :disabled="processingForm"
          >
            {{ $t('login.create_account.create') }}
          </button>
          <button
            id="closeCreateAccountModalBtn"
            class="btn btn-info"
            type="reset"
            :disabled="processingForm"
            @click="modalOpened=false"
          >
            {{ $t('login.create_account.cancel') }}
          </button>
        </div>
      </modal>
    </form>
  </ValidationObserver>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import {email, min, required} from 'vee-validate/dist/rules'
import {Modal} from 'uiv'
import CardFormFields from '@/components/Form/Card/CardFormFields'
import Privacy from '@/components/Form/Card/Privacy'
import PortalTooltip from '@/components/PortalTooltip'
import PortalBackend from '@/api/PortalBackendService'
import json from '@/configuration.json'

setInteractionMode('custom', ({errors}) => {
  if (errors.length) {
    return {
      on: ['input', 'change'],
    }
  }
  return {
    on: ['change'],
    debounce: 100
  }
})

extend('required', required)
extend('email', email)
extend('min', min)

export default {
  components: {PortalTooltip, Modal, ValidationObserver, ValidationProvider, CardFormFields, Privacy},
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      account: {
        email: '',
        agreement: '',
        card: {
          srfid: '',
          name: '',
          amount: ''
        },
      },
      modalOpened: false,
      processingForm: false,
    }
  },
  computed: {
    isDataProtectionUrlSet(){
      return !!(json.gdpr_urls && json.gdpr_urls.data_protection_url)
    }
  },
  watch: {
    modalOpened(newValue) {
      this.$emit('input', newValue)
      if (newValue) {
        this.$refs.form.reset()
        this.account.email = ''
        this.account.card.srfid = ''
        this.account.card.name = ''
        this.account.card.amount = ''
        this.account.agreement = ''
        setTimeout(() => {
          this.$refs.email.focus()
        }, 300)
        this.$refs.privacy.checkboxOff()
      }
    },
    value: {
      immediate: true,
      handler(newValue) {
        this.modalOpened = newValue
      }
    }
  },
  methods: {
    submit() {
      this.processingForm = true

      PortalBackend.createAccount(this.account)
        .then(() => {
          this.$notify({
            type: 'success',
            title: this.$root.$t('login.create_account.account_created_title'),
            content: this.$root.$t('login.create_account.account_created_content'),
            duration: json.notification_duration.success
          })

          this.account = {
            email: '',
            card: {
              srfid: '',
              name: '',
              amount: 0
            },
            agreement: '',
          }

          this.$refs.form.reset()

          this.modalOpened = false
        })
        .catch(({data}) => {
          this.$notify(data, {
            type: 'error',
            title: this.$root.$t('login.create_account.account_creation_failed_title'),
            content: this.$root.$t('login.create_account.account_creation_failed_content'),
            duration: json.notification_duration.error
          })
        })
        .finally(() => this.processingForm = false)
    },
  }
}
</script>
